<template>
  <v-form @submit="onSubmit">
    <tiles-form :tile="doc" />
    <v-btn class="mt-5" @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
// @ is an alias to /src
import TilesForm from "./Form"
import router from "@/router";

export default {
  name: "AdminBenchmarkEdit",
  components: {
    TilesForm
  },
  data () {
    return {
      doc: {}
    }
  },
  created () {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      const updateRef = this.$parent.collection.doc(this.$route.params.id);
      updateRef.set(this.doc).then(() => {
        this.doc = {};
        router.push({ name: this.$parent.returnRoute })
      })
      .catch((error) => {
        alert("Error adding document: ", error);
      });
    }
  }
};
</script>
